"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyStatesRenderer = void 0;
var react_1 = __importDefault(require("react"));
var contentListing_svg_1 = __importDefault(require("../../../assets/images/contentListing.svg"));
var dashboardListing_svg_1 = __importDefault(require("../../../assets/images/dashboardListing.svg"));
var draftsListing_svg_1 = __importDefault(require("../../../assets/images/draftsListing.svg"));
var inPublishedSearch_svg_1 = __importDefault(require("../../../assets/images/inPublishedSearch.svg"));
var mailBoxImg_svg_1 = __importDefault(require("../../../assets/images/mailBoxImg.svg"));
var moderationListing_svg_1 = __importDefault(require("../../../assets/images/moderationListing.svg"));
var publishedListing_svg_1 = __importDefault(require("../../../assets/images/publishedListing.svg"));
var searchDashBoardListing_svg_1 = __importDefault(require("../../../assets/images/searchDashBoardListing.svg"));
var searchListing_svg_1 = __importDefault(require("../../../assets/images/searchListing.svg"));
var Buttons_1 = require("../../Buttons");
var OKELink_1 = require("../../OKELink");
var Typo_1 = require("../../Typo");
var Wrappers_1 = require("../../Wrappers");
var styled_1 = require("./styled");
var styled_2 = require("../PublishedSucccessful/comps/styled");
var ThumbsUpSVG_1 = require("../PublishedSucccessful/comps/ThumbsUpSVG");
var _EXPORTS_1 = require("../../../utils/_EXPORTS");
var mixins_1 = require("../../../themes/mixins");
var PublishedSuccessfullySVGShapes_1 = require("../PublishedSucccessful/comps/PublishedSuccessfullySVGShapes");
var utilsOolib_1 = require("../../../utilsOolib");
var EmptyStatesRenderer = function (_a) {
    var _image = _a.image, _b = _a.align, align = _b === void 0 ? "center" : _b, _title = _a.title, _subtitle = _a.subtitle, link = _a.link, button = _a.button, onClick = _a.onClick, preset = _a.preset;
    var imagesLookup = {
        publishedListing: publishedListing_svg_1.default,
        contentListing: contentListing_svg_1.default,
        draftsListing: draftsListing_svg_1.default,
        moderationListing: moderationListing_svg_1.default,
        inPublishedSearch: inPublishedSearch_svg_1.default,
        searchListing: searchListing_svg_1.default,
        mailBoxImg: mailBoxImg_svg_1.default,
        searchDashBoardListing: searchDashBoardListing_svg_1.default,
        dashboardListing: dashboardListing_svg_1.default,
    };
    var localize = (0, utilsOolib_1.useLocale)();
    //basically image prop can be either the src string or an object with more properties
    var image = typeof _image === "string" ? { src: _image } : _image; // src + style
    var title = typeof _title === "string" ? { text: _title } : _title; // text + style
    var subtitle = typeof _subtitle === "string" ? { text: _subtitle } : _subtitle; // text + style
    var screenwidth = (0, _EXPORTS_1.useScreenWidth)();
    var isTablet = screenwidth > (0, mixins_1.getBreakPoint)("md") && screenwidth < (0, mixins_1.getBreakPoint)("lg");
    return (react_1.default.createElement(styled_1.StyledContainer, { align: align, preset: preset, id: "container" },
        (preset === "successFullyPublish" && screenwidth > (0, mixins_1.getBreakPoint)("md")) && (react_1.default.createElement(PublishedSuccessfullySVGShapes_1.PublishedSuccessfullySVGShapes, { isTablet: isTablet })),
        react_1.default.createElement(Wrappers_1.Wrapper650, { style: { margin: align === "center" ? "auto" : 0, position: "relative" } },
            (image === null || image === void 0 ? void 0 : image.src) && (react_1.default.createElement("img", { src: imagesLookup[image.src], alt: "", style: __assign({ opacity: 0.5, height: "12rem", width: "auto" }, (image.style || {})) })),
            preset === "successFullyPublish" &&
                react_1.default.createElement(styled_2.StyledPublishedSVGWrapper, null,
                    react_1.default.createElement(ThumbsUpSVG_1.ThumbsUpSVG, null)),
            (title === null || title === void 0 ? void 0 : title.text) && (react_1.default.createElement(styled_1.StyledSERIF_4_5, { style: title.style, preset: preset }, localize(title.text))),
            (subtitle === null || subtitle === void 0 ? void 0 : subtitle.text) && (react_1.default.createElement(Typo_1.SANS_3, { style: subtitle.style }, localize(subtitle.text))),
            link && (react_1.default.createElement(Typo_1.SANS_3, { style: { paddingTop: '1rem' } },
                react_1.default.createElement(OKELink_1.OKELink, { text: localize(link.text), onClick: onClick }))),
            button && (react_1.default.createElement(Buttons_1.ButtonPrimary, { onClick: onClick, style: { marginTop: "2rem" } }, localize(button.text))))));
};
exports.EmptyStatesRenderer = EmptyStatesRenderer;
